import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/api/properties',
    method: 'get',
    params
  })
}

export function getOne(id) {
  return request({
    url: `/api/properties/${id}`,
    method: 'get'
  })
}

export function post(data) {
  return request({
    url: '/api/properties',
    method: 'post',
    data
  })
}

export function deleteItem(id) {
  return request({
    url: `/api/properties/${id}`,
    method: 'delete'
  })
}

export function put(id, data) {
  return request({
    url: `/api/properties/${id}`,
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/modules/settings/components/Properties/api.js